module.exports = __webpack_public_path__ + "img/location.59b49d97.svg";